import { render, staticRenderFns } from "./myCollection.vue?vue&type=template&id=a0b56a46&"
import script from "./myCollection.vue?vue&type=script&lang=js&"
export * from "./myCollection.vue?vue&type=script&lang=js&"
import style0 from "./myCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports